import React, { useState, setGlobal, useMemo, useEffect } from "reactn";
import {useGlobal} from "reactn";
import * as API from "../../../../api/api"; // let op het juiste pad
import { Link as RouterLink, useHistory } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import {
  AppBar,
  Toolbar,
  Badge,
  Hidden,
  IconButton,
  Typography,
  Popover,
  List,
  ListItem,
  ListItemText,
  Chip,
  Box,
  Button
} from "@material-ui/core";
import ExitToApp from "@material-ui/icons/ExitToApp";
import MenuIcon from "@material-ui/icons/Menu";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import moment from "moment";
import "moment/locale/nl";
import Warning from "@material-ui/icons/Warning";

moment.locale("nl");

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: "none",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    color: "white"
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
    marginLeft: theme.spacing(1)
  }
}));


// ================================================

const Topbar = props => {
  const { className, onSidebarOpen, ...rest } = props;

  const history = useHistory();
  const onLogOut = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("jwtAuth");
    setGlobal({ user: [] });
    history.push("/login");
  };

  const classes = useStyles();

  // Haal logs uit global (als je die ergens anders opslaat, pas dit aan)
  //const [global] = React.useGlobal ? React.useGlobal() : [window.__dummy, () => {}];
  const [global] = useGlobal();
  const [user] = useGlobal("user");
  

  // zelfde check als in Sidebar:
  const isAdmin = !!(user && (user.admin === true || user.admin === "true"));
  const [logs] = useGlobal("deviceactionlogshash");

    
  // ==== helpers: klepstoringen (status 10..17) ====
  const isKlepstoringCode = (code) =>
    Number.isInteger(code) && code >= 10 && code <= 17;

  const extractLastKlepstoringen = (logs = [], limit = 5) => {
  const oneWeekAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
  const recentLogs = logs.filter(log => {
    const t = new Date(log.eventTime).getTime();
    return !isNaN(t) && t >= oneWeekAgo;
  });

  const sorted = [...recentLogs].sort(
    (a, b) => new Date(b.eventTime) - new Date(a.eventTime)
  );

  const out = [];
  for (const log of sorted) {
    const tube = Object.values(log?.action?.status?.tubeStatus || {});
    const affected = [];
    tube.forEach((code, idx) => {
      if (isKlepstoringCode(code)) affected.push({ index: idx, code });
    });

    if (affected.length > 0) {
      out.push({
        id: `${log.device_hash}-${log.eventTime}-${log?.action?.serial ?? "?"}`,
        device_hash: log.device_hash,
        serial: log?.action?.serial ?? "",
        eventTime: log.eventTime,
        affected
      });
    }

    if (out.length >= limit) break;
  }
  return out;
};

const getDevicesLogsWeek = async (device_hash) => {
  const h = device_hash ?? "";
  if (!h) return;

  try {
    const logs = [];
    const today = new Date();

    for (let i = 0; i < 7; i++) {
      const d = new Date(today);
      d.setDate(today.getDate() - i);
      const dateString = d.toISOString().slice(0, 10);

      try {
        const res = await API.getDeviceActionLogHash(h, dateString);
        if (Array.isArray(res) && res.length > 0) logs.push(...res);
      } catch (err) {
        console.warn(`Kon logs niet ophalen voor ${dateString}:`, err.message);
      }
    }

    setGlobal({ deviceactionlogshash: logs });
  } catch (err) {
    console.error("Weeklogs ophalen mislukt:", err);
  }
};

useEffect(() => {
  if (!user?.device_hash) return;

  const init = async () => {
    try {
      //await API.getDevices();
      await getDevicesLogsWeek(user.device_hash);
    } catch (err) {
      console.error("Topbar init mislukt:", err);
    }
  };

  init();
}, [user?.device_hash]);


  // Bereken laatste 5 klepstoringen
  const alerts = useMemo(() => extractLastKlepstoringen(logs, 5), [logs]);

  // Bel + popover state
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const tubeLabel = (i) => `Slurf ${i + 1}`;

  return (
    <AppBar {...rest} className={clsx(classes.root, className)}>
      <Toolbar>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onSidebarOpen} className={classes.menuButton}>
            <MenuIcon />
          </IconButton>
        </Hidden>

        <RouterLink to="/">
          <Typography className={classes.title} variant="h4" noWrap>
            Luchtslurf App
          </Typography>
        </RouterLink>

        <div className={classes.flexGrow} />

        {/* Belletje met badge en popover */}
        <IconButton
          color="inherit"
          aria-label="Klepstoringen"
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <Badge
			badgeContent={alerts.length}
			color="secondary"
			overlap="rectangular"
			>
			<NotificationsNoneIcon />
			</Badge>
        </IconButton>

        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          PaperProps={{ style: { width: 360, maxWidth: "90vw" } }}
        >
          <Box p={2}>
            <Box fontWeight={600} mb={1}>
              Klepstoringen (laatste {alerts.length})
            </Box>

            {alerts.length === 0 ? (
              <Box color="text.secondary">Geen recente klepstoringen</Box>
            ) : (
              <List dense>
                {alerts.map((a) => (
                  <ListItem key={a.id} alignItems="flex-start">
                    <ListItemText
                      disableTypography
                      primary={<Box fontWeight={600}>{moment(a.eventTime).format("DD MMM YYYY, HH:mm:ss")}</Box>}
                      secondary={
                        <>                          
                          <Box display="flex" flexWrap="wrap" gridGap={6}>
                            {a.affected.map(({ index, code }) => {
                              const isKlepstoring = code >= 10 && code <= 17;
                              return (
                                <Chip
                                  key={`${a.id}-${index}`}
                                  size="small"
                                  icon={
                                    isKlepstoring ? (
                                      <Warning fontSize="small" style={{ color: "red" }} />
                                    ) : undefined
                                  }
                                  label={
                                    isKlepstoring
                                      ? `${a.serial} – ${tubeLabel(index)}: Klep ${code - 9} storing`
                                      : `${a.serial} – ${tubeLabel(index)}: ${code}`
                                  }
                                  variant={isKlepstoring ? "outlined" : "default"}
                                  style={
                                    isKlepstoring
                                      ? { color: "red", borderColor: "red", fontWeight: 600 }
                                      : {}
                                  }
                                />
                              );
                            })}
                          </Box>
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            )}

            <Box display="flex" justifyContent="flex-end" mt={1}>
              <Button onClick={() => setAnchorEl(null)}>Sluiten</Button>
               {isAdmin && (
						<Box ml={1}>
						<Button
							color="primary"
							variant="contained"
							onClick={() => {
							setAnchorEl(null);
							history.push("/klepstoringen"); // jouw admin-only pagina/route
							}}
						>
							Naar pagina
						</Button>
						</Box>
					)}
            </Box>
          </Box>
        </Popover>

        {/* Logout */}
        <Hidden>
          <IconButton
            color="inherit"
            onClick={onLogOut}
            className={classes.signOutButton}
            aria-label="Uitloggen"
          >
            <ExitToApp />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

export default Topbar;
